// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recallModalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 10px;
}

.recallModalFoodType {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 600;
}

.recallModalProductContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recallModalButton {
  background: none;
  border: none;
  cursor: pointer;
}

.recallModalQuantityContainer {
  display: flex;
  padding: 4px 10px;
  border: 1.5px solid var(--surface-g1);
  border-radius: 4px;
  gap: 4px;
}

.recallFormInput {
  border: 0;
  background: transparent;
  min-width: 2ch;
  text-align: center;
  font-size: 0.813rem;
  font-weight: 700;
  color: #8d8787;
}

.recallModalOptionsContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 6px;
  padding-bottom: 10px;
  border-bottom: 1px dashed transparent;
  border-image: repeating-linear-gradient(to right, var(--surface-g2) 0 6px, transparent 6px 12px) 1;
}

.textAreaSection {
  margin-top: 6px;
}

.recallReasonHeader {
  font-weight: 600;
  color: #535861;
  margin-bottom: 4px;
}

.recallInputBox {
  resize: none;
  width: 100%;
  border: 1px solid #d5d7db;
  border-radius: 6px;
  padding: 10px;
  font-size: 1rem;
}

.recallInputBox:focus {
  outline: none;
}

.billConsentContainer {
  display: flex;
  justify-content: flex-start;
}

.recallActionButton {
  margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/RecallOrderModal/RecallOrderModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,kGAAkG;AACpG;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".recallModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 10px;\n}\n\n.recallModalFoodType {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-weight: 600;\n}\n\n.recallModalProductContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.recallModalButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.recallModalQuantityContainer {\n  display: flex;\n  padding: 4px 10px;\n  border: 1.5px solid var(--surface-g1);\n  border-radius: 4px;\n  gap: 4px;\n}\n\n.recallFormInput {\n  border: 0;\n  background: transparent;\n  min-width: 2ch;\n  text-align: center;\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #8d8787;\n}\n\n.recallModalOptionsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-top: 6px;\n  padding-bottom: 10px;\n  border-bottom: 1px dashed transparent;\n  border-image: repeating-linear-gradient(to right, var(--surface-g2) 0 6px, transparent 6px 12px) 1;\n}\n\n.textAreaSection {\n  margin-top: 6px;\n}\n\n.recallReasonHeader {\n  font-weight: 600;\n  color: #535861;\n  margin-bottom: 4px;\n}\n\n.recallInputBox {\n  resize: none;\n  width: 100%;\n  border: 1px solid #d5d7db;\n  border-radius: 6px;\n  padding: 10px;\n  font-size: 1rem;\n}\n\n.recallInputBox:focus {\n  outline: none;\n}\n\n.billConsentContainer {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.recallActionButton {\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
